import { register } from "@shopify/theme-sections";
register("toolbar", {
	onLoad: function () {
		const callChatBtn = document.querySelector(".js-call-chat"),
			toolbarBtn = document.querySelector(".js-toolbar-btn");

		toolbarBtn.addEventListener("click", this.openClose);
		callChatBtn.addEventListener("click", this.callChat);
		LiveChatWidget.on("visibility_changed", this.onVisibilityChanged);
		LiveChatWidget.on("ready", this.onReady);
		toolbarBtn.addEventListener("click", this.openClose);
		callChatBtn.addEventListener("click", this.callChat);
		// eslint-disable-next-line no-undef
		LiveChatWidget.on("visibility_changed", this.onVisibilityChanged);
		// eslint-disable-next-line no-undef
		LiveChatWidget.on("ready", this.onReady);

		const phoneBtn = document.querySelector(".toolbar .toolbar__item-phone"),
			phoneContent = document.querySelector(".toolbar .toolbar__item-phone-content");

		phoneBtn.addEventListener("click", ()=>{
			phoneBtn.classList.add('show');
			phoneContent.classList.add('show');
		});

		phoneContent.addEventListener("click", ()=>{
			phoneBtn.classList.remove('show');
			phoneContent.classList.remove('show');
		});

		setTimeout(function () {
			if (document.querySelector("#chat-widget-container")) {
				document.querySelector("#chat-widget-container").style.display =
					"block";
			}
		}, 2000);
	},
	openClose() {
		const phoneBtn = document.querySelector(".toolbar .toolbar__item-phone"),
			phoneContent = document.querySelector(".toolbar .toolbar__item-phone-content");
		let toolbar = this.closest(".toolbar");
		if (!toolbar.classList.contains("open")) {
			toolbar.classList.add("open");
		} else {
			toolbar.classList.remove("open");
			phoneBtn.classList.remove("show");
			phoneContent.classList.remove("show");
		}
	},
	callChat() {
		const toolbar = document.querySelector(".toolbar"),
			phoneBtn = document.querySelector(".toolbar .toolbar__item-phone"),
			phoneContent = document.querySelector(".toolbar .toolbar__item-phone-content");
		let widget = document.querySelector("#chat-widget-container");
		// eslint-disable-next-line no-undef
		LiveChatWidget.call("maximize");
		widget.style.transition = "height 0.2s";
		setTimeout(function () {
			toolbar.classList.remove("open");
			phoneBtn.classList.remove("show");
			phoneContent.classList.remove("show");
			widget.classList.add("visible");
		}, 300);
	},
	onVisibilityChanged(data) {
		let widget = document.querySelector("#chat-widget-container");
		if (data.visibility == "hidden" || data.visibility == "minimized") {
			widget.classList.remove("visible");
		}
	},
	onReady() {
		document
			.querySelector(".js-call-chat")
			.classList.add("item-chat-active");
	},
});
